module.exports = __webpack_public_path__ + "static/silhouette-c773ea14b26dc3e4613ffaa6a6397465.jpg";